<template lang="pug">
    div.chart(ref='chart' :style="{height: `${height || 600}px`}")
</template>

<script>
import * as echarts from 'echarts/core';
import {
    TitleComponent,
    TooltipComponent,
    GridComponent,
    DataZoomComponent,
} from 'echarts/components';
import { LineChart } from 'echarts/charts';
import { UniversalTransition } from 'echarts/features';
import { CanvasRenderer } from 'echarts/renderers';

echarts.use([
    TitleComponent,
    TooltipComponent,
    GridComponent,
    DataZoomComponent,
    LineChart,
    CanvasRenderer,
    UniversalTransition,
]);

let resizeCallback = null;

export default {
    name: 'LineChart',
    props: { dailydata: Array, height: Number },
    data() {
        return {
            rendered: false,
            $chart: null,
        };
    },
    watch: {
        dailydata(v) {
            if (!this.dailydata || !this.dailydata.length) return;
            if (!this.$data.$chart) {
                this.$data.$chart = echarts.init(this.$refs.chart, 'dark');
                const self = this;
                resizeCallback = () => {
                    self.resizeHandler();
                };
                window.addEventListener('resize', resizeCallback);
            }
            let option;
            const dailydata = this.dailydata;
            const today = new Date(dailydata[0][0]);

            option = {
                backgroundColor: 'rgba(0,0,0,0)',
                tooltip: {
                    trigger: 'axis',
                },
                grid: [
                    {
                        top: '20',
                        left: '50',
                        right: '10',
                        // height: '0%',
                    },
                ],
                xAxis: {
                    type: 'time',
                    boundaryGap: true,
                    max: new Date(
                        `${today.getFullYear()}/${
                            today.getMonth() + 1
                        }/${today.getDate()} 15:00`
                    ).valueOf(),
                    axisLabel: {
                        rotate: 40,
                        interval: 0,
                        showMaxLabel: true,
                        showMinLabel: true,
                    },
                },
                yAxis: {
                    type: 'value',
                    scale: true,
                    // boundaryGap: [0, '100%'],
                },
                // dataZoom: [
                //     {
                //         type: 'inside',
                //         start: 80,
                //         end: 100,
                //         minSpan: 10,
                //     },
                //     {
                //         start: 80,
                //         end: 100,
                //         minSpan: 10,
                //     },
                // ],
                series: [
                    {
                        // name: 'Fake Data',
                        type: 'line',
                        smooth: true,
                        symbol: 'none',
                        data: dailydata,
                    },
                ],
            };

            option && this.$data.$chart.setOption(option);
        },
    },
    mounted() {},
    methods: {
        resizeHandler() {
            this.$data.$chart && this.$data.$chart.resize();
        },
    },
    destroyed() {
        resizeCallback && window.removeEventListener('resize', resizeCallback);
        this.$data.$chart && this.$data.$chart.dispose();
    },
};
</script>

<style lang="stylus" scoped>
.chart
    width 100%
    min-height 200px
</style>
